<template>
    <div class='demo'>
        <div class="page" style="padding: 20px;" >
            <van-button class="test" type="primary" block @click="gotoAuth" >企业微信授权测试</van-button>
        </div>
    </div>
    
</template>
<script>
import {Image as VanImage,Button,Popup,Divider,Toast ,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem, Field} from 'vant';
import env from '@/utils/env'

import VConsole from "vconsole";
var vConsole = new VConsole();


export default {
        name: "epindex",
        components:{
           [Button.name]:Button,
           [Popup.name]:Popup,
           [Field.name]:Field,
        },
        data(){
            return {
                reply_text: "",
                bodyShow: false,
                commentPop: true,
                commentPlaceholder: "发表你的精彩评论~",
                ii: 0,
                canSend: false,//是否可以发送
                show: false,//是否可以发送
            }
        },
        computed: {
          
        },
        watch: {
            //监听输入变化
            reply_text(newV, oldV) {
                console.log(newV)
                newV == '' ? this.canSend = false : this.canSend = true
            }
        },
        created() {
            //this.onPlayerPlay(this.$refs.videoPlayer.player)
            
        },
        
        mounted() {
          var ag = navigator.userAgent.toLowerCase();
          console.log('ag',ag)
          console.log('env.wxwork',env.wxwork)
          
        },
        methods:{
          gotoAuth(){
              console.log("企业微信授权登录")
              
              location.href= '/mini/login/wxwork_platform'+'?token='+this.util.getQueryStr('token')+'&redirect='+encodeURIComponent(location.href);
              // var aa =this.util.getUnifiedUrl()+'?token='+this.util.getQueryStr('token')+'&redirect='+encodeURIComponent(location.href);
              // console.log(aa)
          },
        }
    }

</script>

<style scoped>

.comment_input_box {
  position: fixed;
  bottom:0px;
  /* top:0px; */
  opacity:1;
  z-index: 2999;
  width: 100%;
  border-top: 1px solid #585858;
  background: #1F1F21;
  padding: 10px 15px;
  box-sizing: border-box;
  display: flex;
}
.comment_input{
  flex: 1;
  background: #353539;
  color: #fff;
  border-radius: 16px;
  height: 36px;
  border: none;
  padding-left: 10px;
}
.comment_input_right{
  width: 36px;
  text-align: center;
}
.comment_i{
  font-size: 22px;
  line-height: 36px;
  color: #999;
  transition: .3s;
}
.comment_i_active {
  color: #f44;
}
.comment_input_box2{
  background-color: #1F1F21;
  padding: 10px 15px;
}
</style>